import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'
import SubmitButton from 'component/button/Submit'
import InvalidText from 'component/invalid/text'
import { FormSwitch } from 'component/forms'
import { getMediaDuration } from 'util/global'
import useEditContent from './hook'
import {
  FormInputName,
  FormInputUrutan,
  FormSelectSection,
  FormSelectPrecontent,
  FormInputTanggal,
  FormActiveStatus,
  FormSelectFeedback,
  FormGroupKecil,
  FormActiveKey,
  FormInputDesc,
  FormInputEndedAt,
  PreviewAudioLink,
  InfoGdrive,
  FormTextArea,
  FormSetToBeScore,
} from 'component/content-form'
import FormSelectStudent from 'component/content-form/form-select-student'
import { getUsersContentSpesificStudent } from 'util/array'

export default function EditContentAudio() {
  /* ========================================== Helpers ========================================= */
  const history = useHistory()
  const location = useLocation()
  const params = useParams()
  
  /* ====================================== Consume Context ===================================== */
  const { getRequest, postRequest, putRequest } = useBaseContext()

  /* ======================================= Consume Hook ======================================= */
  const { getContentTakeAway } = useEditContent()
  
  const [selectAudio, setSelectAudio] = useState({
    link: true,
    internal: false,
  })

  /* ========================================= Constants ======================================== */
  const links = [
    { url: '/kelas', name: 'Sub Mata Pelajaran' },
    { url: `/kelas/${location.state.kelasId}`, name: 'Overview' },
  ]

  // EXISTING DATA
  const [sections, setSections]                             = useState(location.state.sectionList || [])
  const [content, setContent]                               = useState(location.state?.dataContent || null)
  const [existingContents, setExistingContents]             = useState([])
  const [existingAudio, setExistingAudio]                   = useState(content.contents_url)
  const [isContentTakeAwayExist, setIsContentTakeAwayExist] = useState(false)

    // INPUT DATA
  const [namaKonten, setNamaKonten]     = useState(`${content.title}`)
  const [urutan, setUrutan]             = useState(`${content.urutan}`)
  const [sectionId, setSectionId]       = useState(`${content.section_id}`)
  const [preContentId, setPrecontentId] = useState(content.precontent_id || '')
  const [active, setActive]             = useState(content.active ? 1 : 0)
  const [displayAt, setDisplayAt]       = useState(content.display_at || '')
  const [feeds, setFeeds]               = useState([])
  const [feedId, setFeedId]             = useState(null)
  const [isFeedActive, setIsFeedActive] = useState(0)
  const [enableGroup, setEnableGroup]   = useState(!!content.group_status)
  const [maxGroup, setMaxGroup]         = useState(content.group_max || '')
  const [descGroup, setDescGroup]       = useState(content.group_description || '')
  const [endedAt, setEndedAt]           = useState(content.ended_at || '')
  const [description, setDescription]   = useState(content.deskripsi || '')
  const [apresiasi, setApresiasi]       = useState(content.apresiasi || '')
  const [rating, setRating]             = useState(content.rating ? 1 : 0)
  const [toBeScore, setToBeScore]   = useState({
    isScore: content.is_score,
    isKeterampilan: content.is_keterampilan,
    isPengetahuan: content.is_pengetahuan,
    selectedTypeScore: content.type_score_id,
    isTypeScoreActive: true,
  })

  const [selectedStudents, setSelectedStudents] = useState(() => getUsersContentSpesificStudent(content))

  //================FILE STATE==================
  const [contentUrl, setContentUrl]                     = useState('')
  const [linkContent, setLinkContent]                   = useState('')
  const [currentAudioFilename, setCurrentAudioFilename] = useState('')
  const [file, setFile]                                 = useState(null)
  const [duration, setDuration]                         = useState(0)

  //================VALID STATE=================
  const [isNamaInvalid, setIsNamaInvalid]         = useState(false)
  const [isUrutanInvalid, setIsUrutanInvalid]     = useState(false)
  const [isSectionInvalid, setIsSectionInvalid]   = useState(false)
  const [isAudioInvalid, setIsAudioInvalid]       = useState(false)
  const [isFileTypeInvalid, setIsFileTypeInvalid] = useState(false)
  const [isMaxGroupValid, setIsMaxGroupValid]     = useState(true)
  const [isUploading, setIsUploading]             = useState(false)

  const [enableGroupKey, setEnableGroupKey] = useState(false)
  const [prerequisite, setPrerequisite]     = useState('')

  // FORM REF
  const refInputName     = useRef()
  const refSelectSection = useRef()
  const refInputUrutan   = useRef()
  const refMaxGroup      = useRef()

  /* ========================================= Functions ======================================== */
  function getExistingContentsBySelectedSection() {
    if (!sectionId) {
      setExistingContents([])
    } else {
      sections.forEach((section) => {
        if (section.id === sectionId) {
          setExistingContents(section.contents)
        }
      })
    }
  }

  async function getFeedsList() {
    const response = await getRequest('feed')
    if (response) {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.description,
      }))
      setFeeds(options)
      initSelectedFeed(options)
    } else {
      console.error('ERROR', response)
    }
  }

  function initSelectedFeed(feedList) {
    for (let feed of feedList) {
      if (feed.value === content.feedback) {
        setFeedId({ value: feed.value, label: feed.label })
        break
      }
    }
  }

  function showAudioChoosed() {
    if (existingAudio.source === 'internal') {
      handleUseInternalFile()
      setCurrentAudioFilename(`${content.id}.mp3`)
      setContentUrl('data tidak berubah')
    } else if (
      existingAudio.source === 'soundcloud' ||
      existingAudio.source === 'gdrive' ||
      existingAudio.source === 'umum'
    ) {
      handleUseLink()
      setLinkContent(existingAudio.data)
      setContentUrl('data tidak berubah')
    } else {
      console.error('tidak ada data audio')
    }
  }

  function handleChangeName(event) {
    setNamaKonten(event.target.value)
  }

  function handleChangeUrutan(event) {
    setUrutan(event.target.value)
  }

  function handleChangeSection(event) {
    setSectionId(event.target.value)
  }

  function handleChangePrecontent(event) {
    setPrecontentId(event.target.value)
  }

  function handleChangeActive() {
    if (active === 1) {
      setActive(0)
    }
    if (active === 0) {
      setActive(1)
    }
  }

  function handleChangeDate(event) {
    setDisplayAt(event.target.value)
  }

  function handleUseLink() {
    setSelectAudio({
      link: true,
      internal: false,
    })
  }
  function handleChangeEnableGroupKey() {
    if (enableGroupKey) {
      setEnableGroupKey(false)
    } else {
      setEnableGroupKey(true)
    }
  }

  function handleUseInternalFile() {
    setSelectAudio({
      link: false,
      internal: true,
    })
  }

  function handleAudioContent(content) {
    if (typeof content === 'string') {
      setLinkContent(content)

      if (content.includes('drive.google.com')) {
        setContentUrl({ name: null, data: content, source: 'gdrive' })
      } else if (content.includes('soundcloud.com')) {
        setContentUrl({ name: null, data: content, source: 'soundcloud' })
      } else {
        setContentUrl({ name: null, data: content, source: 'umum' })
      }
    } else if (`${typeof content}` === 'object') {
      const check = handleValidateMp3(content.name)
      if (check === 'sesuai') {
        setFile(content)
        setCurrentAudioFilename(content.name)
        setContentUrl({
          name: content.name,
          data: 'internal',
          source: 'internal',
        })
      }
    } else {
      setContentUrl(null)
      setFile(null)
      setCurrentAudioFilename('')
    }
  }

  function handleValidateMp3(fileName) {
    const fileExtension = fileName.split('.').pop()
    const mp3Extension = 'mp3'
    if (fileExtension !== mp3Extension) {
      setIsFileTypeInvalid(true)
      return 'tidak sesuai'
    } else {
      setIsFileTypeInvalid(false)
      return 'sesuai'
    }
  }

  function handleChangeFeedback(val) {
    setFeedId(val)
  }

  function handleChangeEnableGroup() {
    if (enableGroup) {
      setEnableGroup(false)
      setMaxGroup(content.group_max ? content.group_max : '')
      setIsMaxGroupValid(true)
    } else {
      setEnableGroup(true)
      setMaxGroup(content.group_max ? content.group_max : '')
      if (content.group_max) {
        setIsMaxGroupValid(true)
      } else {
        setIsMaxGroupValid(false)
      }
    }
  }

  function handleChangeMaxGroup(event) {
    if (event.target.value) {
      const absolute = Math.abs(event.target.value)
      const integer = Math.round(absolute)
      setMaxGroup(integer)
      if (integer <= 0) {
        setIsMaxGroupValid(false)
      } else {
        setIsMaxGroupValid(true)
      }
    } else {
      setMaxGroup('')
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeDescGroup(event) {
    setDescGroup(event.target.value)
  }

  function handleChangeDesc(event) {
    setDescription(event.target.value)
  }

  function handleChangeEndedAt(event) {
    setEndedAt(event.target.value)
  }

  function handleChangeApresiasi(event) {
    setApresiasi(event.target.value)
  }

  function handleChangeRating(value) {
    setRating(value ? 1 : 0)
  }

  function toBeScoreValidation() {
    if (toBeScore.isScore) {
      return (toBeScore.isKeterampilan === true || toBeScore.isPengetahuan === true) && toBeScore.selectedTypeScore
    }

    return true
  }

  function handleValidation() {
    const newUrutan = urutan ? Math.abs(parseInt(urutan)) : 0
    const feedback = isFeedActive === 1 ? feedId : ''

    if (namaKonten && urutan && sectionId && contentUrl && isMaxGroupValid && toBeScoreValidation()) {
      setIsNamaInvalid(false)
      setIsSectionInvalid(false)
      setIsUrutanInvalid(false)
      setIsAudioInvalid(false)
      handleSubmitForm(
        contentUrl,
        namaKonten,
        sectionId,
        newUrutan,
        active,
        displayAt,
        preContentId,
        feedback.value,
        maxGroup,
        descGroup,
        endedAt,
        description,
        apresiasi,
        rating,
      )
    } else {
      if (!isMaxGroupValid) {
        if (refMaxGroup) {
          refMaxGroup.current.focus()
        }
      }

      if (!sectionId) {
        setIsSectionInvalid(true)
        refSelectSection.current.focus()
      } else {
        setIsSectionInvalid(false)
      }

      if (!urutan) {
        setIsUrutanInvalid(true)
        refInputUrutan.current.focus()
      } else {
        setIsUrutanInvalid(false)
      }

      if (!contentUrl) {
        setIsAudioInvalid(true)
      } else {
        setIsAudioInvalid(false)
      }

      if (!namaKonten) {
        setIsNamaInvalid(true)
        refInputName.current.focus()
      } else {
        setIsNamaInvalid(false)
      }

      window.notification('Mohon', 'lengkapi data')

      if (!toBeScoreValidation()) {
        window.notification('Mohon', 'lengkapi juga data "Jadikan Sebagai Penilaian"')
      }
    }
  }

  async function handleSubmitForm(
    contentUrl,
    namaKonten,
    sectionId,
    urutan,
    active,
    displayAt,
    preContentId,
    feedId,
    maxGroup,
    descGroup,
    endedAt,
    description,
    apresiasi,
    rating,
  ) {
    let form = new FormData()
    form.append('duration', duration)
    form.append('id', content.id)
    form.append('content_type', 2)
    form.append('title', namaKonten)
    form.append('section_id', sectionId)
    form.append('urutan', urutan)
    form.append('active', active)
    form.append('rating', rating)
    form.append('precontent_id', preContentId)
    form.append('display_at', displayAt)
    form.append('ended_at', endedAt)
    form.append('deskripsi', description)
    form.append('apresiasi', apresiasi)

    form.append('is_score', !!toBeScore.isScore)

    if (toBeScore.isScore) {
      form.append('is_keterampilan', !!toBeScore.isKeterampilan)
      form.append('is_pengetahuan', !!toBeScore.isPengetahuan)
      form.append('type_score_id', toBeScore.selectedTypeScore)
    }

    if (Array.isArray(selectedStudents) && !!selectedStudents.length) {
      selectedStudents.forEach((selectedStudent, selectedStudentIndex) => {
        form.append(`spesifik_user_id[${selectedStudentIndex}]`, selectedStudent.id)
      })
    }

    if (contentUrl != 'data tidak berubah') {
      form.append('contents_url', JSON.stringify(contentUrl))
      if (contentUrl.source === 'internal') {
        const { id } = JSON.parse(localStorage.getItem('user'))
        const profile_id = JSON.parse(localStorage.getItem('profile')).id
        form.append('path', `upload/${profile_id}/classes/contents`)
        form.append('temp_name', `file-temp-${id}-${Date.now()}.mp3`)
        form.append('file_upload', file)
      }
    }

    if (feedId) {
      form.append('feedback', feedId)
    } else {
      form.append('feedback', '')
    }

    if (enableGroup) {
      form.append('group_status', 1)
    } else {
      form.append('group_status', 0)
    }

    if (maxGroup) {
      form.append('group_max', maxGroup)
    }

    if (descGroup) {
      form.append('group_description', descGroup)
    }

    setIsUploading(true)
    const response = await putRequest('contents', form)
    setIsUploading(false)
    if (response) {
      if (enableGroupKey) {
        let formkey = new FormData()
        formkey.append('description', prerequisite)
        formkey.append('content_id', content.id)

        const response1 = isContentTakeAwayExist
          ? await putRequest('contentTakeAway', formkey)
          : await postRequest('contentTakeAway', formkey)

        if (response1) {
          window.notification('Materi', 'berhasil diubah', 'success')
          history.push(`/kelas/${location.state.kelasId}`)
        }
      } else {
        window.notification('Materi', 'berhasil diubah', 'success')
        history.push(`/kelas/${location.state.kelasId}`)
      }
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getContentTakeAway(content?.id).then((res) => {
      if (res.data) {
        setPrerequisite(res.data.description)
        setEnableGroupKey(true)
        setIsContentTakeAwayExist(true)
      }
    })

    getFeedsList()
  }, [])

  useEffect(() => {
    getExistingContentsBySelectedSection()
    showAudioChoosed()
  }, [sectionId])

  useEffect(() => {
    if (content.feedback !== null) {
      setIsFeedActive(1)
    }
  }, [content.feedback])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header
          pageName="Edit Materi Audio"
          linkName="Materi Audio"
          links={links}
        />
        
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                <h5>
                  <i className="fas fa-volume-up mr-1" />
                  Informasi Audio
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <form>
                      {/* Input Nama Konten */}
                      <FormInputName
                        label="Nama Audio"
                        placeholder="Nama Audio"
                        namaKonten={namaKonten}
                        handleChangeName={handleChangeName}
                        isNamaInvalid={isNamaInvalid}
                        refInputName={refInputName}
                      />

                      {/* Input Audio */}
                      <fieldset className="form-group row mb-5">
                        <label className="col-sm-3 col-form-label">
                          <span className="mr-1">Audio</span>
                        </label>
                        <div className="col-sm-9 row mb-3">
                          <div className="col">
                            <div className="form-check">
                              <input
                                onChange={() => handleUseLink()}
                                className="form-check-input"
                                type="radio"
                                name="selectAudio"
                                id="soundcloud"
                                defaultValue={1}
                                defaultChecked={
                                  existingAudio.source !== 'internal'
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="soundcloud"
                              >
                                <i className="feather icon-link mr-1" />
                                <span>Link</span>
                                <span className="ml-1">
                                  (Google Drive, Soundcloud, atau link umum)
                                </span>
                              </label>
                            </div>
                            {selectAudio.link ? (
                              <div className="mb-4">
                                <InfoGdrive />
                                <input
                                  type="text"
                                  value={linkContent}
                                  onChange={(event) =>
                                    handleAudioContent(event.target.value)
                                  }
                                  className="form-control my-3"
                                  placeholder="Link: : https://drive.google.com/file/d/xyz atau https://soundcloud.com/user/xyz  atau link umum"
                                />
                                {linkContent ? (
                                  <PreviewAudioLink link={linkContent} />
                                ) : null}
                              </div>
                            ) : null}
                            <div className="form-check">
                              <input
                                onChange={() => handleUseInternalFile()}
                                className="form-check-input"
                                type="radio"
                                name="selectAudio"
                                id="uploadAudio"
                                defaultValue={0}
                                defaultChecked={
                                  existingAudio.source === 'internal'
                                    ? true
                                    : false
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="uploadAudio"
                              >
                                <i className="fas fa-file-audio mr-1" />
                                <span>Upload file audio (mp3)</span>
                              </label>
                            </div>
                            {selectAudio.internal ? (
                              <div className="custom-file my-3">
                                <input
                                  type="file"
                                  accept="audio/*"
                                  onChange={async (event) => {
                                    handleAudioContent(event.target.files[0])
                                    let getDur = await getMediaDuration(
                                      event.target.files[0],
                                    )
                                    let durSec = Math.round(getDur)
                                    setDuration(durSec)
                                  }}
                                  className="custom-file-input"
                                  id="input-upload-audio"
                                />
                                <label
                                  className="custom-file-label"
                                  htmlFor="input-upload-audio"
                                >
                                  {currentAudioFilename
                                    ? currentAudioFilename
                                    : 'Pilih file audio'}
                                </label>
                                {isFileTypeInvalid ? (
                                  <label className="col small form-text text-danger">
                                    Type file audio harus mp3.
                                  </label>
                                ) : null}
                              </div>
                            ) : null}
                            {isAudioInvalid ? (
                              <InvalidText name={'Audio'} />
                            ) : null}
                          </div>
                        </div>
                      </fieldset>

                      {/* Input Urutan */}
                      <FormInputUrutan
                        urutan={urutan}
                        isUrutanInvalid={isUrutanInvalid}
                        handleChangeUrutan={handleChangeUrutan}
                        refInputUrutan={refInputUrutan}
                      />

                      {/* Input deskripsi */}
                      <FormInputDesc
                        description={description}
                        handleChangeDesc={handleChangeDesc}
                      />

                      {/* Input Apresiasi */}
                      <FormTextArea
                        id="formInputApresiasi"
                        label="Apresiasi"
                        placeholder="Apresiasi/pesan setelah siswa menyelesaikan materi (opsional)"
                        className="mb-5"
                        value={apresiasi}
                        handleChange={handleChangeApresiasi}
                      />

                      {/* Select Section */}
                      <FormSelectSection
                        sections={sections}
                        existingSectionId={sectionId}
                        handleChangeSection={handleChangeSection}
                        isSectionInvalid={isSectionInvalid}
                        refSelectSection={refSelectSection}
                      />

                      {/* Select Precontent */}
                      <FormSelectPrecontent
                        existingPrecontentId={preContentId}
                        existingContentId={content.id}
                        existingContents={existingContents}
                        handleChangePrecontent={handleChangePrecontent}
                      />

                      {/* Input Tanggal Ditampilkan */}
                      <FormInputTanggal
                        existingDisplayAt={displayAt}
                        handleChangeDate={handleChangeDate}
                      />

                      {/* Input ended at */}
                      <FormInputEndedAt
                        endedAt={endedAt}
                        handleChangeEndedAt={handleChangeEndedAt}
                      />

                      {/* Rating */}
                      <FormSwitch
                        id="formRating"
                        label="Rating Materi"
                        value={rating}
                        handleChange={handleChangeRating}
                      />

                      {/* Select Feedback */}
                      <FormSelectFeedback
                        existingFeedId={feedId}
                        existingFeeds={feeds}
                        isFeedActive={isFeedActive}
                        setIsFeedActive={setIsFeedActive}
                        handleChangeFeeds={handleChangeFeedback}
                        getFeedList={getFeedsList}
                      />

                      {/* Swicth Group Kecil */}
                      <FormGroupKecil
                        enableGroup={enableGroup}
                        handleChangeEnableGroup={handleChangeEnableGroup}
                        maxGroup={maxGroup}
                        descGroup={descGroup}
                        handleChangeMaxGroup={handleChangeMaxGroup}
                        handleChangeDescGroup={handleChangeDescGroup}
                        isMaxGroupValid={isMaxGroupValid}
                        refMaxGroup={refMaxGroup}
                      />

                      {/* Select Specific Students */}
                      <FormSelectStudent 
                        selectedStudents={selectedStudents}
                        setSelectedStudents={setSelectedStudents}
                        subMapelId={params?.kelasId}
                        originalSelectedStudents={getUsersContentSpesificStudent(content)}
                        isDirectSave={false}
                        isWithFooter={false}
                        listSelectedStudentsProps={{
                          listStudentsActions: ['rollback', 'clear-all'],
                        }}
                      />

                      {/* Select To Be Score Or Not */}
                      <FormSetToBeScore
                        value={toBeScore}
                        handleChange={setToBeScore}
                      />

                      {/* Select Active Status */}
                      <FormActiveStatus
                        existingStatus={active}
                        handleChangeStatus={handleChangeActive}
                      />

                      <FormActiveKey
                        enableGroupKey={enableGroupKey}
                        handleChangeEnableGroupKey={handleChangeEnableGroupKey}
                        prerequisite={prerequisite}
                        setPrerequisite={setPrerequisite}
                      />

                      <div className="form-group">
                        <button
                          onClick={() =>
                            history.push(`/kelas/${location.state.kelasId}`)
                          }
                          type="button"
                          className="btn btn-outline-danger has-ripple mr-2"
                        >
                          Kembali
                        </button>
                        {isUploading ? (
                          <button
                            disabled={true}
                            type="button"
                            className="btn btn-success mr-2"
                          >
                            <span
                              className="spinner-border spinner-border-sm mr-1"
                              role="status"
                            />
                            <span>Simpan</span>
                          </button>
                        ) : (
                          <SubmitButton
                            onClick={() => handleValidation()}
                            text="Simpan"
                          />
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
